export const LOADING = 'LOADING';
export const LOGIN = 'LOGIN';
export const STATUS = 'STATUS';
export const USER_UPDATE = 'USER_UPDATE';
